import './Styles.scss'

// Search overlay
class Search {

    constructor() {
        this.overlay = document.querySelector('.search-modal')
        this.searchInput = document.querySelector('#desktop-nav-search')

        this.activeClass = 'active'

        document.addEventListener('keydown', this.keydownListener)
		document.querySelectorAll('.search-btn').forEach((btn) => {
			btn.addEventListener('click', this.openSearch)
		})
        document.querySelector('.btn-search-exit').addEventListener('click', this.closeSearch)
    }

    closeSearch = () => {
        document.querySelector('body').style.overflow = 'auto'
        this.overlay.classList.remove(this.activeClass)
    }

    openSearch = () => {
        document.querySelector('body').style.overflow = 'hidden'
        this.overlay.classList.add(this.activeClass)
        this.searchInput.focus()
    }

    keydownListener = (event) => {
        let isEscape

        if ('key' in event) {
            isEscape = (event.key === 'Escape' || event.key === 'Esc')
        } else {
            isEscape = (event.keyCode === 27)
        }

        if (isEscape) {
            this.closeSearch()
        }
    }
}

new Search()

// Mobile nav bar
const clickEvent = (btn, targetClass, targetElement, event = "click", global) => {
    const serachBtn = document.querySelectorAll(`.${btn}`)[0]
    const body = document.body

    serachBtn.addEventListener("click", () => {
        const target = document.querySelectorAll(`.${targetElement}`)[0]

        if(event === "open") {
            body.style.overflow = "hidden"

            return target.classList.add(targetClass)
        } else if (event === "close") {
            body.style.overflow = "auto"

            return target.classList.remove(targetClass)
        }
    })
}

clickEvent("m-navbar-opener", "active", "mobile-navbar", "open");
clickEvent("close-navbar", "active", "mobile-navbar", "close");

// # Dropdown toggler
(() => {
    const togglers = document.querySelectorAll(`.${"w-m-drop-down__toggler"}`);

    togglers.forEach(toggler => {
        toggler.addEventListener("click", (b) => {
            const parent = b.currentTarget.parentElement.parentElement;
            const dropDown = parent.querySelector(`.${"mddm"}`).classList;
            const openClass = "has-open";

            if(dropDown.contains(openClass)){
                return dropDown.remove(openClass);
            } else {
                return dropDown.add(openClass);
            }
        })
    })
})();
